<template>
    <div>Notifications</div>
</template>

<script>
    export default {
        name: 'Notifications'
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Notifications.vue